import React from 'react';
import styles from './Users.module.scss';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import { BulkSelect, UserActions, UserName, Roles } from './components';

export const getRows = (users: PropertyType[]): PropertyType[] => {
	const getClass = (state: string) => (parseInt(state) ? '' : styles.CellDisabled);

	return users.map((u: PropertyType) => [
		<BulkSelect key={u.user_id} id={u.user_id} />,
		<span key={uuid()} className={getClass(u.state)}>
			{u.user_id}
		</span>,
		<span key={uuid()} className={getClass(u.state)}>
			<UserName user={u} />
		</span>,
		<span key={uuid()} className={getClass(u.state)}>
			{u.email}
		</span>,
		<section key={uuid()}>
			<Roles roles={u.roles} />
		</section>,
		<section key={uuid()} className={styles.UserActions}>
			<UserActions className={styles.Actions} id={u.user_id} />
		</section>,
	]);
};
